import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=6a152b88&"
import script from "./WizardStep.vue?vue&type=script&lang=js&"
export * from "./WizardStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports